export const amenities = [
  {title: '無料高速Wifi', icon: 'fas fa-wifi'},
  {title: '無料の朝食', icon: 'fas fa-mug-hot'},
  {title: '２４時間フロント対応', icon: 'fas fa-clock'},
  {title: '荷物の保管可', icon: 'fas fa-suitcase-rolling'},
  {title: '交通アクセス良好', icon: 'fas fa-bus'},
  // {title: 'フリーキッチン', icon: 'fa fa-cutlery'},
  {title: 'フリーシャワー', icon: 'fas fa-shower'},
  {title: '貸出用充電器有り', icon: 'fas fa-plug'},
  {title: 'ワークスペース有り', icon: 'fas fa-laptop'},
  {title: 'ナイトバー', icon: 'fas fa-glass-martini-alt'},
]